import { BehaviorSubject, filter, map, Observable, pairwise, Subject } from 'rxjs';

import * as object from './object';

class Detector<T = any> {
  private readonly subject: Subject<T>;
  private readonly observable: Observable<T>;

  constructor(initial: T) {
    this.subject = new BehaviorSubject(initial);
    this.observable = this.subject.pipe(
      pairwise(),
      filter(([prev, current]) => !object.equals(prev, current, { strict: true })),
      map(([, current]) => current),
    );
  }

  public next(value: T): void {
    this.subject.next(value);
  }

  public subscribe(listener: (value: T) => void): () => void {
    const subscription = this.observable.subscribe(listener);

    return () => subscription.unsubscribe();
  }
}

export const detector = <T = any>(initial: T): Detector<T> => {
  return new Detector<T>(initial);
};
